module.exports = __webpack_public_path__ + "static/media/Avatars_Male_New-05.437fe7a7.png";